import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import {
  AdapterOptions,
  FlatAnswerMutation,
  SectionAdapter
} from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { RocFormData } from '../../types/RocFormData'
import { RocAssessmentQuestionnaireItem } from '../../types/questionnaire'
import { RocFormField } from '../../types/RocFormField'

export class FinalStepsAdapter extends SectionAdapter<RocFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<RocFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    const finalStepsInternalNotes = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.FINAL_STEPS_INTERNAL_NOTES
    )?.at(0)
    const pendingRequiredDocumentation =
      getAnswerValuesFromItems(
        flatAnswersArray,
        RocAssessmentQuestionnaireItem.FINAL_STEPS_PENDING_REQUIRED_DOCUMENTATION
      ) || []

    return {
      [RocFormField.INTERNAL_NOTES]: finalStepsInternalNotes,
      [RocFormField.PENDING_REQUIRED_DOCUMENTATION]: pendingRequiredDocumentation
    }
  }

  buildFlatAnswers(formData: RocFormData): FlatAnswerMutation[] {
    return [
      {
        linkId: RocAssessmentQuestionnaireItem.FINAL_STEPS_INTERNAL_NOTES,
        value: formData[RocFormField.INTERNAL_NOTES]
      },
      {
        linkId: RocAssessmentQuestionnaireItem.FINAL_STEPS_PENDING_REQUIRED_DOCUMENTATION,
        value: formData[RocFormField.PENDING_REQUIRED_DOCUMENTATION]
      }
    ]
  }
}
